import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import axios from "../api/axios";
import { environment } from "../global/environment";
import { verifyCI, verifyPhone } from "../utils/validators";
import { toast } from "react-toastify";
import { clearAccessToken } from "../utils/accessToken";
import CountrySelect from "./CountrySelect";

export function BasicDataTab({ candidateId, candidateInfo }) {
  const {
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useFormContext();
  
  const [showDeleteAccount, setShowDeleteAccount] = useState(false);
  const [isInternalUser, setIsInternalUser] = useState(window.isInternalUser);

  const citiesToRelocate = [
    {
      id: "tacuarembo",
      name: "Tacuarembó",
    },
    {
      id: "rivera",
      name: "Rivera",
    },
    {
      id: "cerrolargo",
      name: "Cerro Largo",
    },
    {
      id: "montevideo",
      name: "Montevideo",
    },
    {
      id: "treintaytres",
      name: "Treinta y Tres",
    },
  ];
  const hasHealthCard = watch("hasHealthCard");
  const willingToRelocate = watch("willingToRelocate");
  const hasDriveCard = watch("hasDriveCard");
  const documentType = watch("documentType");
  const countryLocation = useWatch({
    name: "location.country",
  });

  const emailValue = watch("email");

  const onDeleteAccount = () => {
    axios.delete(environment.candidateUri + candidateId).then(
      () => {
        //Show toasts
        toast.success(
          "Se eliminó correctamente el perfil, redireccionando...",
          {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
        setTimeout(() => {
          clearAccessToken();
          window.location.reload();
        }, 4000);
      },
      () => {
        //Show error
        toast.error("Ocurrió un error al eliminar el perfil.", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    );
  };

  return (
    <div className="c-profile-info__switchable" data-content="1">
      <h3 className="u-hidden-for-seo">Datos Básicos</h3>
      <div className="c-profile-info__section c-form__section">
        <div className="c-form__row c-form__row--2col">
          <label className="c-form__group c-form__col">
            <span className="c-form__label">Nombre </span>
            <input
              type="text"
              id="form-name"
              name="name"
              {...register("name", { required: true })}
              className="c-form__input"
              placeholder="Ingresa tu nombre"
            />
            {errors.name && errors.name.type === "required" && (
              <span className="c-form__error">Este campo es obligatorio</span>
            )}
          </label>

          <label className="c-form__group c-form__col">
            <span className="c-form__label">Apellido </span>
            <input
              type="text"
              id="form-lastname"
              name="lastName"
              {...register("lastName", { required: true })}
              className="c-form__input"
              placeholder="Ingresa tu apellido"
            />
            {errors.lastName && errors.lastName.type === "required" && (
              <span className="c-form__error">Este campo es obligatorio</span>
            )}
          </label>
        </div>
        <div className="c-form__row c-form__row--2col">
          <label className="c-form__group c-form__col c-form__col--small">
            <span className="c-form__label">Tipo de documento</span>
            <span className="c-form__select">
              <select
                className="c-form__input"
                name="c-form__col--small"
                id="c-form__col--small"
                defaultValue={"ci"}
                {...register("documentType")}
              >
                <option value="ci">CI</option>
                <option value="passport">Pasaporte</option>
              </select>
            </span>
          </label>
          {documentType === "passport" ? (
            <label className="c-form__group c-form__col">
              <span className="c-form__label">Número de pasaporte</span>
              <input
                type="text"
                id="form-ci"
                name="document"
                {...register("documentNumber", { required: true })}
                className="c-form__input"
                placeholder="Ingresa tu documento"
              />
              {errors.document && errors.documentType === "required" && (
                <span className="c-form__error">Este campo es obligatorio</span>
              )}
            </label>
          ) : (
            <label className="c-form__group c-form__col">
              <span className="c-form__label">Cédula de identidad</span>
              <input
                type="text"
                id="form-ci"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                name="document"
                {...register("documentNumber", {
                  required: true,
                  validate: verifyCI,
                })}
                className="c-form__input"
                placeholder="Ingresa tu documento"
              />
              {errors.documentNumber &&
                errors.documentNumber.type === "required" && (
                  <span className="c-form__error">
                    Este campo es obligatorio
                  </span>
                )}
              {errors.documentNumber &&
                errors.documentNumber.type === "validate" && (
                  <span className="c-form__error">
                    El documento ingresado no es válido
                  </span>
                )}
            </label>
          )}
        </div>
        <div className="c-form__row c-form__row--2col">
          <label className="c-form__group c-form__col c-form__col--small">
            <span className="c-form__label">Ascendencia étnica</span>
            <span className="c-form__select">
              <select
                className="c-form__input"
                name="ethnicOrigin"
                id="ethnicOrigin"
                defaultValue={"ethnicOrigin"}
                {...register("ethnicOrigin", { required: true })}
              >
                <option value="" disabled>
                  Seleccione
                </option>
                <option value="blanco">Blanco</option>
                <option value="afro">Afro</option>
                <option value="asiatico">Asiatico</option>
                <option value="indigena">Indigena</option>
                <option value="otra">Otra</option>
              </select>
            </span>
            {errors.ethnicOrigin && errors.ethnicOrigin.type === "required" && (
                <span className="c-form__error">Este campo es obligatorio</span>
            )}
        </label>
        <label className="c-form__group c-form__col c-form__col--small">
            <span className="c-form__label">Identidad de género</span>
            <span className="c-form__select">
              <select
                className="c-form__input"
                name="c-form__col--small"
                id="c-form__col--small"
                defaultValue={"sex"}
                {...register("sex", { required: true })}
              >
                <option value="select" disabled>
                  Seleccione
                </option>
                <option value="male">Varón</option>
                <option value="female">Mujer</option>
                <option value="male_trans">Varón trans</option>
                <option value="female_trans">Mujer trans</option>
                <option value="no_answer">No sabe/No contesta</option>
                <option value="other">Otra</option>
              </select>
            </span>
            {errors.sex && errors.sex.type === "required" && (
                <span className="c-form__error">Este campo es obligatorio</span>
            )}
          </label>
        </div>
        <div className="c-form__row c-form__row--2col">
          <label className="c-form__group c-form__col ">
            <span className="c-form__label">Fecha de nacimiento </span>
            <input
              type="date"
              id="form-birth"
              defaultValue={getValues("birthday")}
              name="birthday"
              {...register("birthday", { required: true })}
              className="c-form__input "
            />
            {errors.birthday && errors.birthday.type === "required" && (
              <span className="c-form__error">Este campo es obligatorio</span>
            )}
          </label>
          <label className="c-form__group c-form__col c-form__col--small">
            <span className="c-form__label">País de Origen o de Nacimiento</span>
            <span className="c-form__select">
              <select
                className="c-form__input"
                name="originCountry"
                id="originCountry"
                defaultValue={"originCountry"}
                {...register("originCountry", { required: true })}
              >
                <option value="" disabled>
                  Seleccione un país
                </option>
                <option value="afghanistan">Afganistán</option>
                <option value="albania">Albania</option>
                <option value="alemania">Alemania</option>
                <option value="andorra">Andorra</option>
                <option value="angola">Angola</option>
                <option value="antigua-barbuda">Antigua y Barbuda</option>
                <option value="arabia-saudita">Arabia Saudita</option>
                <option value="argelia">Argelia</option>
                <option value="argentina">Argentina</option>
                <option value="armenia">Armenia</option>
                <option value="australia">Australia</option>
                <option value="austria">Austria</option>
                <option value="azerbaiyan">Azerbaiyán</option>
                <option value="bahamas">Bahamas</option>
                <option value="bangladesh">Bangladés</option>
                <option value="barbados">Barbados</option>
                <option value="barein">Baréin</option>
                <option value="belgica">Bélgica</option>
                <option value="belice">Belice</option>
                <option value="benin">Benín</option>
                <option value="bielorrusia">Bielorrusia</option>
                <option value="birmania">Birmania (Myanmar)</option>
                <option value="bolivia">Bolivia</option>
                <option value="bosnia-herzegovina">Bosnia y Herzegovina</option>
                <option value="botsuana">Botsuana</option>
                <option value="brasil">Brasil</option>
                <option value="brunei">Brunéi</option>
                <option value="bulgaria">Bulgaria</option>
                <option value="burkina-faso">Burkina Faso</option>
                <option value="burundi">Burundi</option>
                <option value="butan">Bután</option>
                <option value="cabo-verde">Cabo Verde</option>
                <option value="camboya">Camboya</option>
                <option value="camerun">Camerún</option>
                <option value="canada">Canadá</option>
                <option value="catar">Catar</option>
                <option value="chad">Chad</option>
                <option value="chile">Chile</option>
                <option value="china">China</option>
                <option value="chipre">Chipre</option>
                <option value="colombia">Colombia</option>
                <option value="comoras">Comoras</option>
                <option value="corea-del-norte">Corea del Norte</option>
                <option value="corea-del-sur">Corea del Sur</option>
                <option value="costa-de-marfil">Costa de Marfil</option>
                <option value="costa-rica">Costa Rica</option>
                <option value="croacia">Croacia</option>
                <option value="cuba">Cuba</option>
                <option value="dinamarca">Dinamarca</option>
                <option value="dominica">Dominica</option>
                <option value="ecuador">Ecuador</option>
                <option value="egipto">Egipto</option>
                <option value="el-salvador">El Salvador</option>
                <option value="emiratos-arabes-unidos">Emiratos Árabes Unidos</option>
                <option value="eritrea">Eritrea</option>
                <option value="eslovaquia">Eslovaquia</option>
                <option value="eslovenia">Eslovenia</option>
                <option value="espana">España</option>
                <option value="estados-unidos">Estados Unidos</option>
                <option value="estonia">Estonia</option>
                <option value="etiopia">Etiopía</option>
                <option value="filipinas">Filipinas</option>
                <option value="finlandia">Finlandia</option>
                <option value="fiyi">Fiyi</option>
                <option value="francia">Francia</option>
                <option value="gabon">Gabón</option>
                <option value="gambia">Gambia</option>
                <option value="georgia">Georgia</option>
                <option value="ghana">Ghana</option>
                <option value="granada">Granada</option>
                <option value="grecia">Grecia</option>
                <option value="guatemala">Guatemala</option>
                <option value="guinea">Guinea</option>
                <option value="guinea-bisau">Guinea-Bisáu</option>
                <option value="guinea-ecuatorial">Guinea Ecuatorial</option>
                <option value="guyana">Guyana</option>
                <option value="haiti">Haití</option>
                <option value="honduras">Honduras</option>
                <option value="hungria">Hungría</option>
                <option value="india">India</option>
                <option value="indonesia">Indonesia</option>
                <option value="irak">Irak</option>
                <option value="iran">Irán</option>
                <option value="irlanda">Irlanda</option>
                <option value="islandia">Islandia</option>
                <option value="israel">Israel</option>
                <option value="italia">Italia</option>
                <option value="jamaica">Jamaica</option>
                <option value="japon">Japón</option>
                <option value="jordania">Jordania</option>
                <option value="kazajistan">Kazajistán</option>
                <option value="kenia">Kenia</option>
                <option value="kirguistan">Kirguistán</option>
                <option value="kiribati">Kiribati</option>
                <option value="kosovo">Kosovo</option>
                <option value="kuwait">Kuwait</option>
                <option value="laos">Laos</option>
                <option value="letonia">Letonia</option>
                <option value="libano">Líbano</option>
                <option value="liberia">Liberia</option>
                <option value="libia">Libia</option>
                <option value="liechtenstein">Liechtenstein</option>
                <option value="lituania">Lituania</option>
                <option value="luxemburgo">Luxemburgo</option>
                <option value="macedonia-del-norte">Macedonia del Norte</option>
                <option value="madagascar">Madagascar</option>
                <option value="malasia">Malasia</option>
                <option value="malaui">Malaui</option>
                <option value="maldivas">Maldivas</option>
                <option value="mali">Malí</option>
                <option value="malta">Malta</option>
                <option value="marruecos">Marruecos</option>
                <option value="marshall">Islas Marshall</option>
                <option value="mauricio">Mauricio</option>
                <option value="mauritania">Mauritania</option>
                <option value="mexico">México</option>
                <option value="micronesia">Micronesia</option>
                <option value="moldavia">Moldavia</option>
                <option value="monaco">Mónaco</option>
                <option value="mongolia">Mongolia</option>
                <option value="montenegro">Montenegro</option>
                <option value="mozambique">Mozambique</option>
                <option value="namibia">Namibia</option>
                <option value="nauru">Nauru</option>
                <option value="nepal">Nepal</option>
                <option value="nicaragua">Nicaragua</option>
                <option value="niger">Níger</option>
                <option value="nigeria">Nigeria</option>
                <option value="noruega">Noruega</option>
                <option value="nueva-zelanda">Nueva Zelanda</option>
                <option value="oman">Omán</option>
                <option value="paises-bajos">Países Bajos</option>
                <option value="pakistan">Pakistán</option>
                <option value="palaos">Palaos</option>
                <option value="palestina">Palestina</option>
                <option value="panama">Panamá</option>
                <option value="papua-nueva-guinea">Papúa Nueva Guinea</option>
                <option value="paraguay">Paraguay</option>
                <option value="peru">Perú</option>
                <option value="polonia">Polonia</option>
                <option value="portugal">Portugal</option>
                <option value="reino-unido">Reino Unido</option>
                <option value="republica-centroafricana">República Centroafricana</option>
                <option value="republica-checa">República Checa</option>
                <option value="republica-congo">República del Congo</option>
                <option value="republica-democratica-congo">República Democrática del Congo</option>
                <option value="republica-dominicana">República Dominicana</option>
                <option value="ruanda">Ruanda</option>
                <option value="rumania">Rumanía</option>
                <option value="rusia">Rusia</option>
                <option value="samoa">Samoa</option>
                <option value="san-cristobal-nieves">San Cristóbal y Nieves</option>
                <option value="san-marino">San Marino</option>
                <option value="san-vicente-granadinas">San Vicente y las Granadinas</option>
                <option value="santa-lucia">Santa Lucía</option>
                <option value="santo-tome-principe">Santo Tomé y Príncipe</option>
                <option value="senegal">Senegal</option>
                <option value="serbia">Serbia</option>
                <option value="seychelles">Seychelles</option>
                <option value="sierra-leona">Sierra Leona</option>
                <option value="singapur">Singapur</option>
                <option value="siria">Siria</option>
                <option value="somalia">Somalia</option>
                <option value="sri-lanka">Sri Lanka</option>
                <option value="sudafrica">Sudáfrica</option>
                <option value="sudan">Sudán</option>
                <option value="sudan-del-sur">Sudán del Sur</option>
                <option value="suecia">Suecia</option>
                <option value="suiza">Suiza</option>
                <option value="surinam">Surinam</option>
                <option value="tailandia">Tailandia</option>
                <option value="tanzania">Tanzania</option>
                <option value="tayikistan">Tayikistán</option>
                <option value="timor-oriental">Timor Oriental</option>
                <option value="togo">Togo</option>
                <option value="tonga">Tonga</option>
                <option value="trinidad-tobago">Trinidad y Tobago</option>
                <option value="tunez">Túnez</option>
                <option value="turkmenistan">Turkmenistán</option>
                <option value="turquia">Turquía</option>
                <option value="tuvalu">Tuvalu</option>
                <option value="ucrania">Ucrania</option>
                <option value="uganda">Uganda</option>
                <option value="uruguay">Uruguay</option>
                <option value="uzbekistan">Uzbekistán</option>
                <option value="vanuatu">Vanuatu</option>
                <option value="vaticano">Ciudad del Vaticano</option>
                <option value="venezuela">Venezuela</option>
                <option value="vietnam">Vietnam</option>
                <option value="yemen">Yemen</option>
                <option value="yibuti">Yibuti</option>
                <option value="zambia">Zambia</option>
                <option value="zimbabue">Zimbabue</option>
              </select>
            </span>
            {errors.originCountry && errors.originCountry.type === "required" && (
                <span className="c-form__error">Este campo es obligatorio</span>
            )}
          </label>
          </div>
        <div className="c-form__row c-form__row--2col">
          <label className="c-form__group c-form__col">
            <span className="c-form__label">Teléfono de contacto </span>
            <input
              type="tel"
              id="form-phone"
              name="phone"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              {...register("phone", { required: true, validate: verifyPhone })}
              className="c-form__input"
              placeholder="Ingresa un número de teléfono o celular"
            />
            {errors.phone && errors.phone.type === "required" && (
              <span className="c-form__error">Este campo es obligatorio</span>
            )}
            {errors.phone && errors.phone.type === "validate" && (
              <span className="c-form__error">
                El teléfono/celular no es válido
              </span>
            )}
          </label>
          <label className="c-form__group c-form__col">
            <span className="c-form__label">Email</span>
            <input
              type="email"
              id="form-email"
              name="email"
              {...register("email", { required: true })}
              className="c-form__input"
              placeholder="Ingresa tu correo electrónico"
              disabled={emailValue && emailValue.trim() !== ""}
            />
            {errors.email && errors.email.type === "required" && (
              <span className="c-form__error">Este campo es obligatorio</span>
            )}
          </label>
         </div>
        {!isInternalUser && (<>
          {documentType === "passport" && (
            <div className="c-form__row">
              <span className="c-form__label c-form__label--mb">
                ¿Está en trámite de residencia?
              </span>
              <label
                className="c-form__radio u-tap-size"
                htmlFor="isForeignWithDocumentInProcess-si"
              >
                <input
                  className="c-form__radio-input"
                  type="radio"
                  id="isForeignWithDocumentInProcess-si"
                  name="isForeignWithDocumentInProcess"
                  value="1"
                  {...register("isForeignWithDocumentInProcess")}
                />
                <span className="c-form__radio-btn"></span>
                <span className="c-form__label c-form__label--radio">Si</span>
              </label>
              <label
                className="c-form__radio u-tap-size"
                htmlFor="isForeignWithDocumentInProcess-no"
              >
                <input
                  className="c-form__radio-input"
                  type="radio"
                  id="isForeignWithDocumentInProcess-no"
                  name="isForeignWithDocumentInProcess"
                  value="0"
                  {...register("isForeignWithDocumentInProcess")}
                />
                <span className="c-form__radio-btn"></span>
                <span className="c-form__label c-form__label--radio">No</span>
              </label>
            </div>
          )}
          <div className="c-form__row">
            <span className="c-form__label c-form__label--mb">
              ¿Está inscripto en{" "}
              <a
                href="https://viatrabajo.mtss.gub.uy/viatrabajoweb/servlet/inicio"
                target="_blank"
                rel="noreferrer"
              >
                VÍA TRABAJO
              </a>
              ? Es una plataforma de servicios vinculados a la información,
              orientación, capacitación e intermediación laboral del Ministerio de
              Trabajo.
            </span>
            <label className="c-form__radio u-tap-size" htmlFor="viatrabajo-si">
              <input
                className="c-form__radio-input"
                type="radio"
                id="viatrabajo-si"
                name="viatrabajo"
                value="1"
                {...register("extraData.registeredOnViaTrabajo")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">Si</span>
            </label>
            <label className="c-form__radio u-tap-size" htmlFor="viatrabajo-no">
              <input
                className="c-form__radio-input"
                type="radio"
                id="viatrabajo-no"
                name="viatrabajo"
                value="0"
                {...register("extraData.registeredOnViaTrabajo")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">No</span>
            </label>
          </div>
          <div className="c-form__row">
            <span className="c-form__label c-form__label--mb">
              ¿Está inscripto en el Registro Nacional de Personas con Discapacidad
              según la ley 19.691?
            </span>
            <label className="c-form__radio u-tap-size" htmlFor="discapacidad-si">
              <input
                className="c-form__radio-input"
                type="radio"
                id="discapacidad-si"
                name="registeredAsPersonsDisabilities"
                value="1"
                {...register("registeredAsPersonsDisabilities")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">Si</span>
            </label>
            <label className="c-form__radio u-tap-size" htmlFor="discapacidad-no">
              <input
                className="c-form__radio-input"
                type="radio"
                id="discapacidad-no"
                name="registeredAsPersonsDisabilities"
                value="0"
                {...register("registeredAsPersonsDisabilities")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">No</span>
            </label>
          </div>
          <div className="c-form__row">
            <span className="c-form__label c-form__label--mb">
              ¿Posee libreta de conducir?{" "}
            </span>
            <label className="c-form__radio u-tap-size" htmlFor="libreta-si">
              <input
                className="c-form__radio-input"
                type="radio"
                id="libreta-si"
                name="hasDriveCard"
                value="1"
                onClick={() => {
                  setValue("driversCard", "");
                }}
                {...register("hasDriveCard")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">Si</span>
            </label>
            <label className="c-form__radio u-tap-size" htmlFor="libreta-no">
              <input
                className="c-form__radio-input"
                type="radio"
                id="libreta-no"
                name="hasDriveCard"
                value="0"
                onClick={() => {
                  setValue("driversCard", "");
                  setValue("driversCardNew", "");
                }}
                {...register("hasDriveCard")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">No</span>
            </label>
          </div>
          {hasDriveCard === "1" && (
            <div className="c-form__row">
              <span className="c-form__label c-form__label--mb">
                Indique qué libreta/as de conducir posee{" "}
              </span>
              <div className="c-form__checkbox-holder">
                <label className="c-form__checkbox" htmlFor="libreta-cat-a">
                  <input
                    className="c-form__checkbox-input"
                    type="checkbox"
                    id="libreta-cat-a"
                    value="catA"
                    defaultChecked={
                      getValues("driversCard")
                        ? getValues("driversCard").indexOf("catA") > -1
                        : false
                    }
                    {...register("driversCardNew", { required: true })}
                  />
                  <span className="c-form__checkbox-btn"></span>
                  <span className="c-form__label c-form__label--checkbox">
                    Categoría A
                  </span>
                </label>
                <label className="c-form__checkbox" htmlFor="libreta-cat-b">
                  <input
                    className="c-form__checkbox-input"
                    type="checkbox"
                    id="libreta-cat-b"
                    value="catB"
                    defaultChecked={
                      getValues("driversCard")
                        ? getValues("driversCard").indexOf("catB") > -1
                        : false
                    }
                    {...register("driversCardNew", { required: true })}
                  />
                  <span className="c-form__checkbox-btn"></span>
                  <span className="c-form__label c-form__label--checkbox">
                    Categoría B
                  </span>
                </label>
                <label className="c-form__checkbox" htmlFor="libreta-cat-h">
                  <input
                    className="c-form__checkbox-input"
                    type="checkbox"
                    id="libreta-cat-h"
                    value="catH"
                    defaultChecked={
                      getValues("driversCard")
                        ? getValues("driversCard").indexOf("catH") > -1
                        : false
                    }
                    {...register("driversCardNew", { required: true })}
                  />
                  <span className="c-form__checkbox-btn"></span>
                  <span className="c-form__label c-form__label--checkbox">
                    Categoría H
                  </span>
                </label>
              </div>
              {errors.driversCardNew &&
                errors.driversCardNew.type === "required" && (
                  <span className="c-form__error">
                    Debe seleccionar el menos una opción
                  </span>
                )}
            </div>
          )}
          <div className="c-form__row c-form__row--2col">
            <div className="c-form__col">
              <span className="c-form__label c-form__label--mb">
                ¿Posee carnet de salud?{" "}
              </span>
              <label className="c-form__radio u-tap-size" htmlFor="salud-si">
                <input
                  className="c-form__radio-input"
                  type="radio"
                  id="salud-si"
                  name="hasHealthCard"
                  value="1"
                  onClick={() => {
                    setValue("healthCardExpiration", "");
                  }}
                  {...register("hasHealthCard")}
                />
                <span className="c-form__radio-btn"></span>
                <span className="c-form__label c-form__label--radio">Si</span>
              </label>
              <label className="c-form__radio u-tap-size" htmlFor="salud-no">
                <input
                  className="c-form__radio-input"
                  type="radio"
                  id="salud-no"
                  name="hasHealthCard"
                  value="0"
                  onClick={() => {
                    setValue("healthCardExpiration", "");
                  }}
                  {...register("hasHealthCard")}
                />
                <span className="c-form__radio-btn"></span>
                <span className="c-form__label c-form__label--radio">No</span>
              </label>
            </div>
            {hasHealthCard === "1" && (
              <div className="c-form__col">
                <label className="c-form__group">
                  <span className="c-form__label">
                    Fecha de vencimiento del carnet de salud
                  </span>
                  <input
                    type="date"
                    id="salud-vencimiento"
                    defaultValue={
                      hasHealthCard ? getValues("healthCardExpiration") : ""
                    }
                    name="healthCardExpiration"
                    className="c-form__input c-form__input--small"
                    {...register("healthCardExpiration", { required: true })}
                  />
                  {errors.healthCardExpiration &&
                    errors.healthCardExpiration.type === "required" && (
                      <span className="c-form__error">
                        Este campo es obligatorio
                      </span>
                    )}
                </label>
              </div>
            )}
          </div>
          <CountrySelect
            label="País de residencia"
            register={register}
            setValue={setValue}
            errors={errors}
            countryPath="location.country"
            otherCountryPath="location.other"
            cityPath="location.city"
            selectedCountry={countryLocation}
            defaultCityValue=""
          />
          <div className="c-form__row">
            <span className="c-form__label c-form__label--mb">
              ¿Está dispuesto a trasladarse a otro departamento?{" "}
            </span>
            <label className="c-form__radio u-tap-size" htmlFor="traslado-si">
              <input
                className="c-form__radio-input"
                type="radio"
                id="traslado-si"
                name="willingToRelocate"
                value="1"
                onClick={() => {
                  setValue("willingToRelocateInfo", "");
                  setValue("willingToRelocateInfoNew", "");
                }}
                {...register("willingToRelocate")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">Si</span>
            </label>
            <label className="c-form__radio u-tap-size" htmlFor="traslado-no">
              <input
                className="c-form__radio-input"
                type="radio"
                id="traslado-no"
                name="willingToRelocate"
                value="0"
                onClick={() => {
                  setValue("willingToRelocateInfo", "");
                  setValue("willingToRelocateInfoNew", "");
                }}
                {...register("willingToRelocate")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">No</span>
            </label>
          </div>
          {willingToRelocate === "1" && (
            <div className="c-form__row">
              <span className="c-form__label c-form__label--mb">
                Indique cuál/es departamentos está dispuesto a trasladarse{" "}
              </span>
              <div className="c-form__checkbox-holder">
                {citiesToRelocate.map((city) => {
                  return (
                    <label
                      className="c-form__checkbox"
                      htmlFor={`relocate-info-${city.id}`}
                    >
                      <input
                        className="c-form__checkbox-input"
                        type="checkbox"
                        id={`relocate-info-${city.id}`}
                        value={city.id}
                        defaultChecked={
                          getValues("willingToRelocateInfo")
                            ? getValues("willingToRelocateInfo").indexOf(
                                city.id
                              ) > -1
                            : false
                        }
                        {...register("willingToRelocateInfoNew", {
                          required: true,
                        })}
                        // Se guardan los nuevos valores en willingToRelocateInfoNew
                      />
                      <span className="c-form__checkbox-btn"></span>
                      <span className="c-form__label c-form__label--checkbox">
                        {city.name}
                      </span>
                    </label>
                  );
                })}
              </div>
              {errors.willingToRelocateInfoNew &&
                errors.willingToRelocateInfoNew.type === "required" && (
                  <span className="c-form__error">
                    Debe seleccionar el menos una opción
                  </span>
                )}
            </div>
          )}
          <div className="c-form__row">
            <span className="c-form__label c-form__label--mb">
              ¿Desea recibir información sobre nuevas ofertas laborales?{" "}
            </span>
            <label className="c-form__radio u-tap-size" htmlFor="newsletter-si">
              <input
                className="c-form__radio-input"
                type="radio"
                id="newsletter-si"
                name="receiveJobOfferNotifications"
                value="1"
                {...register("receiveJobOfferNotifications")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">Si</span>
            </label>
            <label className="c-form__radio u-tap-size" htmlFor="newsletter-no">
              <input
                className="c-form__radio-input"
                type="radio"
                id="newsletter-no"
                name="receiveJobOfferNotifications"
                value="0"
                {...register("receiveJobOfferNotifications")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">No</span>
            </label>
          </div>
          <div className="c-form__row">
            <span className="c-form__label c-form__label--mb">
              ¿Usted es colaborador actual de Lumin?
            </span>
            <label className="c-form__radio u-tap-size" htmlFor="isInternalEmployee-si">
              <input
                className="c-form__radio-input"
                type="radio"
                id="isInternalEmployee-si"
                name="isInternalEmployee"
                value="1"
                onClick={(e) => {
                  setValue("wasEmployee", "");
                  setValue("internalEmployeeFrom", "");
                  setValue("internalEmployeeTo", "");
                  setValue("internalEmployeeArea", "");
                }}
                {...register("isInternalEmployee")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">Sí</span>
            </label>
            <label className="c-form__radio u-tap-size" htmlFor="isInternalEmployee-no">
              <input
                className="c-form__radio-input"
                type="radio"
                id="isInternalEmployee-no"
                name="isInternalEmployee"
                value="0"
                onClick={(e) => {
                  setValue("wasEmployee", candidateInfo.wasEmployee ?? "0");
                  setValue("internalEmployeeFrom", candidateInfo.internalEmployeeFrom ?? "");
                  setValue("internalEmployeeTo", candidateInfo.internalEmployeeTo ?? "");
                  setValue("internalEmployeeArea", candidateInfo.internalEmployeeArea ?? "");
                }}
                {...register("isInternalEmployee")}
              />
              <span className="c-form__radio-btn"></span>
              <span className="c-form__label c-form__label--radio">No</span>
            </label>
          </div>

          {watch("isInternalEmployee") === "0" && (
            <div className="c-form__row">
              <span className="c-form__label c-form__label--mb">
                ¿Fue colaborador de Lumin?
              </span>
              <label className="c-form__radio u-tap-size" htmlFor="wasEmployee-si">
                <input
                  className="c-form__radio-input"
                  type="radio"
                  id="wasEmployee-si"
                  name="wasEmployee"
                  value="1"
                  onClick={(e) => {
                    setValue("internalEmployeeFrom", candidateInfo.internalEmployeeFrom ?? "");
                    setValue("internalEmployeeTo", candidateInfo.internalEmployeeTo ?? "");
                    setValue("internalEmployeeArea", candidateInfo.internalEmployeeArea ?? "");
                  }}
                  {...register("wasEmployee")}
                />
                <span className="c-form__radio-btn"></span>
                <span className="c-form__label c-form__label--radio">Sí</span>
              </label>
              <label className="c-form__radio u-tap-size" htmlFor="wasEmployee-no">
                <input
                  className="c-form__radio-input"
                  type="radio"
                  id="wasEmployee-no"
                  name="wasEmployee"
                  value="0"
                  onClick={(e) => {
                    setValue("internalEmployeeFrom", "");
                    setValue("internalEmployeeTo", "");
                    setValue("internalEmployeeArea", "");
                  }}
                  {...register("wasEmployee")}
                />
                <span className="c-form__radio-btn"></span>
                <span className="c-form__label c-form__label--radio">No</span>
              </label>
            </div>
          )}

          {watch("wasEmployee") === "1" && watch("isInternalEmployee") === "0" && (
            <div className="c-form__row c-form__row--2col">
              <label className="c-form__group c-form__col">
                <span className="c-form__label">Período desde</span>
                <input
                  type="date"
                  id="internalEmployeeFrom"
                  name="internalEmployeeData.from"
                  {...register("internalEmployeeData.from", { required: true })}
                  className="c-form__input"
                />
                {errors.internalEmployeeData?.from && (
                  <span className="c-form__error">Este campo es obligatorio</span>
                )}
              </label>
              <label className="c-form__group c-form__col">
                <span className="c-form__label">Período hasta</span>
                <input
                  type="date"
                  id="internalEmployeeTo"
                  name="internalEmployeeData.to"
                  {...register("internalEmployeeData.to", { required: true })}
                  className="c-form__input"
                />
                {errors.internalEmployeeData?.to && (
                  <span className="c-form__error">Este campo es obligatorio</span>
                )}
              </label>
              <label className="c-form__group c-form__col">
                <span className="c-form__label">Área en la que trabajó</span>
                <input
                  type="text"
                  id="internalEmployeeArea"
                  name="internalEmployeeData.area"
                  {...register("internalEmployeeData.area", { required: true })}
                  className="c-form__input"
                  placeholder="Ingresa el área"
                />
                {errors.internalEmployeeData?.area && (
                  <span className="c-form__error">Este campo es obligatorio</span>
                )}
              </label>
            </div>
          )}
          <button
            type="button"
            onClick={() => setShowDeleteAccount(true)}
            className="c-form__btn c-form__btn-delete c-form__btn c-form__btn-delete--bottom u-tap-size"
          >
            <span className="c-form__btn-icon icon-delete"></span>Eliminar cuenta
          </button>
        </>)}
      </div>
      {/* <!-- .c-popup : Add className='is-active' to display: block; Add className='is-showing' to show animation --> */}
      <div
        id="c-delete-account"
        className={`c-popup c-popup--recover c-popup--xs c-popup--login js-popup ${
          showDeleteAccount ? "is-visible" : ""
        }`}
        style={{ display: showDeleteAccount ? "block" : "none" }}
      >
        <div className="c-popup__wrapper">
          <p className="c-login__title">Eliminar mi cuenta</p>
          <div className="c-login__links">
            <p className="c-login__signup">
              ¿Estás seguro que deseas eliminar tu cuenta?
            </p>
            <button
              className="c-login__link c-login__link--recover js-showPopup"
              data-popup="c-delete-account"
              onClick={onDeleteAccount}
              type="button"
            >
              Confirmar
            </button>
          </div>
          <button
            type="button"
            className="c-login__submit c-form__submit c-btn u-tap-size js-form__submit"
            onClick={() => setShowDeleteAccount(false)}
          >
            <span className="c-btn__loader"></span>
            <span className="js-form__submit-text" data-text="Eliminar">
              Cancelar
            </span>
          </button>
          <button
            onClick={() => setShowDeleteAccount(false)}
            className="c-popup__close icon-close u-tap-size js-hidePopup"
            type="button"
          ></button>
        </div>
      </div>
    </div>
  );
}
